import authAxios from 'modules/shared/axios/authAxios';

export default class ClusterService {
  static async update(id, data) {
    const body = {
      id,
      data,
    };

    const response = await authAxios.put(
      `/cluster/${id}`,
      body,
    );

    return response.data;
  }

  static async destroyAll(ids) {
    const params = {
      ids,
    };

    const response = await authAxios.delete(`/cluster`, {
      params,
    });

    return response.data;
  }

  static async create(data) {
    const body = {
      data,
    };

    const response = await authAxios.post(
      `/cluster`,
      body,
    );

    return response.data;
  }

  static async import(values, importHash) {
    const body = {
      data: values,
      importHash,
    };

    const response = await authAxios.post(
      `/cluster/import`,
      body,
    );

    return response.data;
  }

  static async find(id) {
    const response = await authAxios.get(`/cluster/${id}`);
    return response.data;
  }

  static async list(filter, orderBy, limit, offset) {
    const params = {
      filter,
      orderBy,
      limit,
      offset,
    };

    const response = await authAxios.get(`/cluster`, {
      params,
    });

    return response.data;
  }

  static async listAutocomplete(query, limit) {
    const params = {
      query,
      limit,
    };

    const response = await authAxios.get(
      `/cluster/autocomplete`,
      {
        params,
      },
    );

    return response.data;
  }

  static async statusCluster(id) {

    const response = await authAxios.get(
      `/cluster/${id}/status`
    );

    return response.data;
  }

  static async getCompartmentSizes(id) {
    try {
      const response = await authAxios.get(`/cluster/${id}/status`);
      const sizes = Object.keys(response.data.status || {}).filter(size =>
        response.data.status[size].total_compartiments > 0
      );
      return sizes;
    } catch (error) {
      console.error('Error fetching compartment sizes:', error);
      return [];
    }
  }
}
